var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyHeart = function SvgEmptyHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.85 12.065 13.5 23l10.65-10.935A6.57 6.57 0 0 0 26 7.482C26 3.902 23.173 1 19.686 1c-1.674 0-3.28.683-4.464 1.898L13.5 4.667l-1.722-1.769A6.231 6.231 0 0 0 7.313 1C3.827 1 1 3.902 1 7.482a6.57 6.57 0 0 0 1.85 4.583Z"
  })));
};
export default SvgEmptyHeart;